import React, { createContext, useEffect, useState } from "react";

export const AuthContext = createContext(null);

// const APIURL = 'http://localhost:3000'
// const ideadeskUrl = 'http://localhost:5173'

const APIURL = 'https://test.myideadesk.com/'
const ideadeskUrl = 'https://test.myideadesk.com/'


export const AuthProvider = ({ children }) => {
    const [user, setuser] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        console.log('window.location.search', window.location.search)
        const params = new URLSearchParams(window.location.search)
        console.log('params are', params)
        let token = params.get('token') || localStorage.getItem('token')
        console.log('token', token)
        if (!token) {
            window.location.href = `${ideadeskUrl}`;
            console.log('no token')
            return
        }
        validateUser(token)
    }, [])

    const validateUser = async (token) => {
        try {
            const path = `${APIURL}/api/user/profile`
            const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
            const response = await fetch(path, { method: 'GET', headers })
            console.log('response', response)
            if (response.status !== 200) {
                localStorage.removeItem('token')
                window.location.href = `${ideadeskUrl}`;
                return
            }
            localStorage.setItem('token', token)
            const responseBody = await response.json()
            console.log('responseBody', responseBody)
            setuser(responseBody.user)

        } catch (e) {
            localStorage.removeItem('token')
            console.log('error', e)
            window.location.href = `${ideadeskUrl}`;


        } finally {
            setLoading(false)
            // window.history.replaceState({}, document.title, "/");
            console.log('window.location.pathname', window.location.pathname)
            console.log('document.title', document.title)
            // remove token from url
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }

    return (
        <AuthContext.Provider value={{ user, loading }}>
            {children}
        </AuthContext.Provider>
    )
}

